// extracted by mini-css-extract-plugin
export default {"QuoteErrorCard":"quoteErrorCard-module_QuoteErrorCard_SWzO_","Title":"quoteErrorCard-module_Title_ZT4yN","SidebarHeaderIcon":"quoteErrorCard-module_SidebarHeaderIcon_cl4e2"};